import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import sprintf from 'i18next-sprintf-postprocessor';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// TODO: check the reactifi i18n code to see if we need to keep any of that
// TODO: figure out what namespaces we'll use

export const locales = [
  'en',
  'ar-AE',
  'bg-BG',
  'cs-CZ',
  'da-DK',
  'de',
  'el-GR',
  'en-GB',
  'es',
  'es-419',
  'es-ES',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'he-IL',
  'hi-IN',
  'hu-HU',
  'id-ID',
  'it',
  'ja',
  'km-KH',
  'ko',
  'ms-MY',
  'my-MM',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'ro-RO',
  'ru',
  'sk-SK',
  'sl-SI',
  'sr-RS',
  'sv-SE',
  'th-TH',
  'tl-PH',
  'tr-TR',
  'uk-UA',
  'vi-VN',
  'zh-CN',
  'zh-TW',
  'zh-HK',
];

i18n
  .use(LanguageDetector)
  .use(sprintf)
  .use(HttpBackend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init(
    {
      // TODO: try to limit this to the list of locales on the current org?
      languages: locales,
      supportedLngs: locales,
      fallbackLng: ['en'],
      ns: ['common', 'reactifi'],
      defaultNS: 'common',
      fallbackNS: ['common', 'reactifi'],
      // debug: true,
      keySeparator: '>',
      react: {
        useSuspense: true,
      },
      nsSeparator: '|',
      returnObjects: true,
      returnEmptyString: false,
      interpolation: {
        escapeValue: false,
        formatSeparator: ',',
        format: function (value, format) {
          if (format === 'uppercase') return value.toUpperCase();
          return value;
        },
      },
      backend: {
        loadPath: '/locales/{{ns}}/{{lng}}/translations.json',
      },
      detection: {
        order: ['path'],
        convertDetectedLanguage: detectedString => {
          if (!locales.includes(detectedString)) {
            return 'en';
          }
          return detectedString;
        },
      },
    },
    (err, t) => {
      if (err) {
        console.error('i18next error: %s', err);
      }
    }
  );

export default i18n;
